<div class="flex flex-col h-full">
    <div 
        #scrollContainer
        class="grid grid-cols-1 lg:grid-cols-1 items-start gap-2 flex-1 overflow-y-auto px-20"
        (scroll)="onScroll()">
        @if(!_orderWizardService.loading$() && containerTextArray!=[]) {
            <ng-container [ngTemplateOutlet]="component_loaded"></ng-container>
        }
        @else {
            <ng-container [ngTemplateOutlet]="component_loading"></ng-container>
        }
    </div>

    <form [formGroup]="_orderWizardService.formGroup">
        <div [formGroupName]="_orderWizardService.modelNames.step05.key">
            <h5 class="flex justify-end text-color-primary-500">   
                <corp-checkbox 
                    [formControlName] = "_orderWizardService.modelNames.step05.fields.isGtcAccepted.key"
                    class="transition-all duration-300 px-4 py-2 text-white rounded"
                    [class.bg-secondary-500]="isScrollAtBottom"
                    [class.bg-gray-800]="!isScrollAtBottom"
                    [corp-label]="'i18n.app.features.pages.order.wizard.step_05.tac.checkbox_01' | translate">
                </corp-checkbox>
            </h5>
        </div>
    </form>
</div>

<ng-template #component_loading>
    <corp-loading></corp-loading>
</ng-template>

<ng-template #component_loaded>

    <div class="text-center">
        <a routerLink="/" class="inline-block max-w-[100px] pb-10">
            <img src="images/logo_loomisFx.png" alt="logo" class="inline-block dark:hidden">
            <img src="images/logo_loomisFx_dark.png" alt="logo" class="hidden dark:inline-block">
        </a>
        <!-- general conditions of sales -->
        <h3>{{ `i18n.app.features.pages.front-pages.legal.term-of-sale.title_page` | translate }}</h3>
        <!-- for the sale of foreign currency -->
        <h3>{{ `i18n.app.features.pages.front-pages.legal.term-of-sale.sub_title_page` | translate }}</h3>
    </div>

    @for(containerText of containerTextArray; track containerText.index){
        <h2 class="text-xl font-semibold text-petrol-500 border-b-5 border-b-primary-500">
            {{ `i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_${containerText.index}` | translate }}
        </h2>

        @for(blockText of containerText.blockTextArray; track blockText; let i = $index) {
            @let displayIndex = containerText.index + '_' + ($index + 1).toString().padStart(2, '0');
            @switch(blockText.type){
                @case('p'){
                    <!-- P_{{displayIndex}} -->
                   
                    <p class="text-sm text-secondary-400">
                        {{ `i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_${displayIndex}` | translate }}
                    </p>
                }
                @case('bp'){

                    <!-- BP_{{displayIndex}}                      -->
                     <p class="flex items-center gap-1 text-gray-500 ">
                        <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                            target
                        </span>
                        <!--i18n - Loomis FXGS (foreign currency sales execution) -->
                        {{ `i18n.app.features.pages.front-pages.legal.term-of-sale.component.bp_${displayIndex}` | translate }}
                    </p>
                }
                @default {}
            }
        }
    }

</ng-template>